module.exports = __webpack_public_path__ + "img/tree-01-i-leaves.4628925b.png";